import React, {Component} from 'react';
import {Api} from '../../api';
import {setAuthData, encodeString, getAuthToken} from '../../utils';
import TextFieldInput from '../Common/TextFieldInput'
import ButtonInput from '../Common/ButtonInput'
import {Redirect} from 'react-router-dom';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import {InputAdornment, IconButton} from '@material-ui/core';
import {withRouter} from 'react-router';
import {PropyLogoIcon} from '../Common/Icons/Icons'
import Loader from '../Common/Loader'
import { usersActions } from '../../redux/actions';
import { connect } from 'react-redux';

import './TransactionHistory.scss';
import SelectInput from "../Common/SelectInput";


class TransactionHistory extends Component {

    state = {
        history: [],
    };

    componentDidMount() {
        const authToken = getAuthToken();

        Api.get(`transaction/history`, authToken)
            .then((response) => {
                if (response.data.length > 0) this.setState({history: response.data});
            }).catch((error) => {
                console.error('error', error);
            });
    }

    render() {
        const {history} = this.state;
        return (
            <div>
                {history.length > 0 ?
                    <div className="content transactions-history">
                        <div className="content-h2">Transactions history</div>
                        <div className="hr-content"/>
                        <div className="content-body content-right">
                            <div className="transactions-history">
                                <div className="header">
                                    <div className="date-time">Date & Time</div>
                                    <div className="transaction-id">Transaction ID</div>
                                    <div className="amount-cur">Amount & Cur.</div>
                                    <div className="status">Status</div>
                                    <div className="description">Description</div>
                                </div>
                                {history.map((transaction, index) => {
                                    return (
                                        <div
                                            onClick={() => this.props.history.push(`/user/transaction/${transaction.id}`)}
                                            className={`transaction-item ${transaction.transactionStatus}`} key={index}>
                                            <div className="date-time">{transaction.dateAndTime}</div>
                                            <div className="transaction-id">{transaction.txId}</div>
                                            <div className="amount-cur">{transaction.amountAndCurrency}</div>
                                            <div className="status">{transaction.transactionStatus}</div>
                                            <div className="description">{transaction.description}</div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                    :
                    <div className="content transactions-history">
                        <div className="content-h2">Transactions history</div>
                        <div className="hr-content"/>
                        <div className="content-body empty-entity">
                            Your history is empty.
                        </div>
                    </div>}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {};
}
export default connect(mapStateToProps)(withRouter(TransactionHistory));


// WEBPACK FOOTER //
// ./src/components/TransactionHistory/TransactionHistory.js